import { BaseViewStore} from 'core/stores';
import { action, observable } from "mobx";

class FacilityOrderTemplateNewFlowDeleteModalStore extends BaseViewStore {
    @observable accessor disabled = false;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.item = this.modalParams.data.item;
        this.numberOfTemplates = this.modalParams.data.numberOfTemplates && this.modalParams.data.numberOfTemplates;
        this.isNewPatient = this.modalParams.data.isNewPatient;
    }

    @action.bound
    async deleteTemplate() {
        this.disabled = true;
        try {
            await this.modalParams.data.deleteTemplate();
            this.modalParams.close();
        }
        catch (err) {
            return this.onUpdateError(err);
        }
        this.disabled = false;
    }
}

export default FacilityOrderTemplateNewFlowDeleteModalStore;
